import React, {Component} from "react";

export class StatistikComponent extends Component{
    render(){
        return(
            <section id="statistik_sektoral">
                <div className="container">
                    <div className="row content">
                        <div className="col-md-4 order-1 order-md-2" data-aos="fade-left">
                            <img src={`${process.env.PUBLIC_URL}/template/img/details-3.png`} className="img-fluid" alt="" />
                        </div>
                        <div className="col-md-8 pt-5" data-aos="fade-up">
                            <h2 className="flex-content"><i className="bx bx-chart mr-1"></i><b> Statistik Sektoral</b></h2>
                            <br/>
                            <h3>Dapatkan Data statistik sektoral</h3>
                            <p className="font-size-medium font-weight-100">
                                Dapatkan Data statistik sektoral wilayah Kabupaten Sampang secara akurat.
                            </p>
                            <br/><br/>
                            <a href="https://short.sampangkab.go.id/851526-42992" className="download-btn">Buka Statistik Sektoral</a>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default StatistikComponent;